<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppCabecalho from '@/components/AppCabecalho'
import ListagemGenerica from '@/components(new)/UI/Tables/ListagemGenerica/ListagemGenerica.vue'
import RegistrationTypeModal from '@/components(new)/UI/Modals/RegistrationType/RegistrationType.vue'
import FiltroGenerico from '@/components(new)/UI/Filters/FiltroGenerico/FiltroGenerico.vue'
import TitlePage from '@/components(new)/UI/Typography/TitlePage/TitlePage.vue'
import BaseTable from '@/components(new)/UI/Tables/BaseTable/BaseTable.vue'
import CustomButton from '@/components(new)/UI/Buttons/CustomButton/CustomButton.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import AppModalVisualizarCadastro from '@/components(new)/UI/Modals/VisualizacaoCadastro/AppModalVisualizarCadastro.vue'
import EMPTY_FILTRO_PROCESSO_CENTRAL from '@/libs/models/filtro/emptyFiltroProcessoCentral'
import ConfirmacaoParceria from '@/components(new)/UI/Modals/ConfirmacaoParceria/ConfirmacaoParceria.vue'
import VisualizarDocumentos from '@/components(new)/UI/Modals/VisualizarDocumentos/VisualizarDocumentos.vue'

export default {
  mixins: [
    AppNotificacao
  ],
  components: {
    AppCabecalho,
    ListagemGenerica,
    RegistrationTypeModal,
    FiltroGenerico,
    TitlePage,
    BaseTable,
    CustomButton,
    InputSelect,
    AppModalVisualizarCadastro,
    ConfirmacaoParceria,
    VisualizarDocumentos
  },
  data () {
    return {
      filtro: EMPTY_FILTRO_PROCESSO_CENTRAL('CAIXA_FINALIZADOS'),
      totalElements: 0,
      totalPages: 0,
      processos: [],
      modalVisible: false,
      municipios: [],
      status: [],
      protocolo: null,
      modalVisualizarCadastro: false,
      modalVisualizarParceriaIsOpen: false,
      textoParceria: null,
      modalVisualizarDocumentoIsOpen: false,
      documentos: [],
      tituloVisualizarDocumento: null
    }
  },
  mounted () {
    this.loadLista()
    this.getMunicipios()
    this.getStatus()
  },
  methods: {
    ...mapActions({
      getProcessos: 'listagem/getItemsProcessos',
      delete: 'listagem/delete',
      findStatusByCaixa: 'status/findByCaixa',
      findMunicipioByCadastros: 'municipios/findMunicipioByCadastros',
      getLaudosViewByProcessoId: 'vistoria/getLaudosViewByProcessoId',
      getLaudosMonitoramentoAmbientalByIdProcesso: 'monitoramentoAmbiental/getLaudosByIdProcesso',
      prepararEdicaoByIdProcesso: 'cadastro/prepararEdicaoByIdProcesso'
    }),
    async loadLista () {
      const response = await this.getProcessos(this.filtro)
      this.processos = this.formatarDadosTabela(response.content)
      this.totalElements = response.totalElements
      this.totalPages = response.totalPages
    },
    formatarDadosTabela (dados) {
      const getVinculoIconProps = (statusVinculo) => {
        switch (statusVinculo) {
          case 'AGUARDANDO_CONFIRMACAO':
            return {
              statusVinculoIcon: 'fal fa-user-clock',
              statusVinculoIconColor: '#F4B327',
              statusTooltip: 'Aguardando confirmação de parceria'
            }
          case 'COMPARTILHADO':
            return {
              statusVinculoIcon: 'fal fa-user-check',
              statusVinculoIconColor: '#009F61',
              statusTooltip: 'Em compartilhamento'
            }
          case 'RECUSADO':
            return {
              statusVinculoIcon: 'fal fa-user-lock',
              statusVinculoIconColor: '#f37576',
              statusTooltip: 'Compartilhamento interrompido'
            }
          default:
            return {}
        }
      }
      return dados.map(dado => ({
        ...dado,
        ...getVinculoIconProps(dado.statusVinculo),
        actions: [
          { key: 'visualizarProcesso', label: 'Visualizar Processo', icon: 'fa fa-eye', action: this.viewCadastro },
          { key: 'visualizarLaudoPreliminar', label: 'Visualizar Laudo de análise preliminar', icon: 'fa fa-eye', action: () => this.visualizarLaudoAnalisePreliminar(dado.id), show: dado.hasLaudoPreliminar },
          { key: 'visualizarLaudoVistoria', label: 'Visualizar Laudo de vistoria', icon: 'fa fa-eye', action: () => this.visualizarLaudoVistoria(dado.id), show: dado.hasLaudoVistoria },
          { key: 'confirmarParceria', label: 'Confirmar parceria', icon: 'fa fa-check', action: this.openModalVisualizarParceria, show: dado.statusVinculo === 'AGUARDANDO_CONFIRMACAO' && dado.tipoSolicitacaoVinculo === 'DESTINATARIO' },
          { key: 'editarCadastro', label: (dado.hasEdicaoPendente ? 'Continuar Edição' : 'Editar'), icon: 'pencil-alt', action: () => this.editarProcesso(dado.id), show: dado.podeEditar }
        ]
      }))
    },
    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.loadLista()
    },
    pesquisar (pesquisaSimples) {
      this.filtro.campoSimples = pesquisaSimples
      this.filtro.pagina = 0
      this.loadLista()
    },
    limparPesquisa () {
      this.filtro = EMPTY_FILTRO_PROCESSO_CENTRAL('CAIXA_FINALIZADOS')
      this.loadLista()
    },
    async getMunicipios () {
      const municipios = await this.findMunicipioByCadastros()
      this.municipios = municipios.map(municipio => { return {id: municipio.id, nome: municipio.nome} })
    },
    async getStatus () {
      const status = await this.findStatusByCaixa('CAIXA_FINALIZADOS')
      this.status = status.map(status => ({id: status.codigo, nome: status.nome}))
    },
    viewCadastro (dadosTabela) {
      this.protocolo = dadosTabela.numeroProtocolo
      this.modalVisualizarCadastro = true
    },
    closeModalVisualizarCadastro () {
      this.modalVisualizarCadastro = false
      this.protocolo = null
    },
    openModalVisualizarParceria (dadosTabela) {
      this.protocolo = dadosTabela.numeroProtocolo
      this.textoParceria = dadosTabela.mensagemVinculo
      this.modalVisualizarParceriaIsOpen = true
    },
    closeModalVisualizarParceria () {
      this.modalVisualizarParceriaIsOpen = false
      this.protocolo = null
      this.textoParceria = null
    },
    async visualizarLaudoVistoria (idProcesso) {
      this.documentos = await this.getLaudosViewByProcessoId(idProcesso)
      this.tituloVisualizarDocumento = 'Laudo de Vistoria'
      this.openModalVisualizarDocumento()
    },
    async visualizarLaudoAnalisePreliminar (idProcesso) {
      this.tituloVisualizarDocumento = 'Laudo de Análise Preliminar'
      this.documentos = await this.getLaudosMonitoramentoAmbientalByIdProcesso(idProcesso)
      this.openModalVisualizarDocumento()
    },
    async openModalVisualizarDocumento () {
      if (!this.documentos?.length) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Documento não encontrado.')
        return
      }
      this.modalVisualizarDocumentoIsOpen = true
    },
    closeModalVisualizarDocumento () {
      this.modalVisualizarDocumentoIsOpen = false
      this.documentos = []
      this.tituloVisualizarDocumento = null
    },
    async editarProcesso (idProcesso) {
      const { id, modalidadeCadastro } = await this.prepararEdicaoByIdProcesso(idProcesso)

      this.$router.push({
        name: modalidadeCadastro.codigo === 'EMPRESA' ? 'formulario-imovel' : 'formulario-proprietario',
        params: { idCadastro: id, tipoCadastro: modalidadeCadastro.codigo }
      })
    }
  }
}
</script>

<template>
  <div class="container praticas-sustentaveis">
    <AppModalVisualizarCadastro
      v-if="modalVisualizarCadastro"
      :protocolo="protocolo"
      @closeModal="closeModalVisualizarCadastro"
    />
    <ConfirmacaoParceria
      v-if="modalVisualizarParceriaIsOpen"
      @closeModal="closeModalVisualizarParceria"
      @atualizarListagem="limparPesquisa"
      :protocolo="protocolo"
      :texto="textoParceria"
    />
    <VisualizarDocumentos
      v-if="modalVisualizarDocumentoIsOpen"
      @closeModal="closeModalVisualizarDocumento"
      :titulo="tituloVisualizarDocumento"
      :documentos="documentos"
    />
    <div class="content-cadastro">
      <TitlePage
        title="Bem-vindo(a) ao Plano ABC+ PA"
        subTitle="Abaixo estão listados os processos disponíveis para consulta."
      />
      <div class="flex-start mt-3 mb-3">
        <FiltroGenerico
          placeholder="Pesquisar por número do processo, nome do proprietário ou CPF/CNPJ proprietário..."
          widthInput="98%"
          @filtrosPesquisa="pesquisar"
          @limpar="limparPesquisa"
        >
          <template #filtros>
            <InputSelect
              label="Municípios:" v-model="filtro.municipios"
              :multiSelect="true"
              :opcoes="municipios"
            />
            <InputSelect
              label="Status:" v-model="filtro.status"
              :opcoes="status"
            />
          </template>
        </FiltroGenerico>
      </div>
      <BaseTable
        title="Listagem"
        :tableData="processos"
        :columns="[
          { key: 'statusVinculoIcon', label: '', type: 'icon', color: row => row.statusVinculoIconColor, tooltip: row => row.statusTooltip, width: 50 },
          { key: 'numeroProcesso', label: 'Número do processo' },
          { key: 'proprietarioNomeRazaoSocial', label: 'Proprietário' },
          { key: 'proprietarioCpfCnpj', label: 'CPF/CNPJ' },
          { key: 'nomeImovel', label: 'Nome do imóvel' },
          { key: 'municipio', label: 'Município' },
          { key: 'cadastranteNomeRazaoSocial', label: 'Cadastrante' },
          { key: 'statusFormatado', label: 'Status do Processo' },
          { key: 'actions', label: 'Ações' }
        ]"
        :pagination="{
          show: true,
          pageSize: filtro.tamanhoPagina,
          totalPages: totalPages,
          totalElements: totalElements
        }"
        @pageChange="changePage"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/listagem-finalizados/listagem-finalizados.vue